// src/components/facility/DeskPanel.js
import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

export function DeskPanel({ title, onClose, state, children }) {
  useEffect(() => {
    function handleKey(e) {
      if (e.key !== 'Escape') return;
      // Don't steal Escape from higher-priority modals
      if (
        (state?.phenoCandidates ?? null) !== null ||
        state?.corporateOfferAvailable ||
        state?.tutorial?.enabled
      ) return;
      onClose();
    }
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose, state]);

  return (
    <motion.div
      initial={{ y: '100%', opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: '100%', opacity: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      style={{
        position: 'absolute',
        bottom: 0, left: 0, right: 0,
        maxHeight: '55%',
        background: '#14120e',
        border: '1px solid #3a3028',
        borderBottom: 'none',
        borderRadius: '8px 8px 0 0',
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: '0 -4px 24px rgba(0,0,0,0.7)',
      }}
    >
      {/* Header */}
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '10px 16px',
        borderBottom: '1px solid #2a2018',
        flexShrink: 0,
        background: '#18150f',
      }}>
        <div style={{ fontWeight: 700, fontSize: 13, color: 'var(--text)', letterSpacing: '0.03em' }}>
          {title}
        </div>
        <button
          onClick={onClose}
          style={{
            background: 'none', border: 'none',
            color: 'var(--text-dim)', cursor: 'pointer',
            fontSize: 18, padding: '0 2px', lineHeight: 1,
          }}
          onMouseEnter={e => e.currentTarget.style.color = 'var(--text)'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--text-dim)'}
        >✕</button>
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflow: 'auto', padding: '12px 16px' }}>
        {children}
      </div>
    </motion.div>
  );
}
